import React, { FunctionComponent } from 'react';

import { DonateButtonFormData } from '../../../../types/givingCheckoutForm';
import { DonateButtonProps } from '../DonateButtonTypes';
import WidgetButtonCode from '../WidgetButtonCode';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const JustGivingButton: FunctionComponent<DonateButtonProps> = ({
  linkId,
  codeBlockType,
  isDefault,
}) => {
  const { register } = useFormContext<DonateButtonFormData>();
  const { t } = useTranslation();

  return (
    <>
      <fieldset className="jg-form-group">
        <label
          className="jg-form-label jg-space-mbxs jg-color--nero"
          htmlFor="select-buttonSize"
        >
          {t('donateButton.chooseSize')}
        </label>
        <select
          className="select justgivingDonateButton__selectSize"
          id="select-buttonSize"
          {...register('buttonSize')}
        >
          <option value="large">{t('donateButton.buttonSizeLarge')}</option>
          <option value="small">{t('donateButton.buttonSizeSmall')}</option>
        </select>
      </fieldset>
      <p>{t('donateButton.embedCodeHeading')}</p>
      <WidgetButtonCode
        codeBlockType={codeBlockType}
        buttonType="justgiving"
        widgetType="donateButton"
        linkId={linkId}
        isDefault={isDefault}
      />
    </>
  );
};

export default JustGivingButton;
